import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { t, translate } from "restaumatic-client/src/I18n";
import { useState } from "preact/hooks";
function Alert(props) {
    var _a;
    const { message, type, variant = "default", extraClasses = variant === "default" ? "u-mt2" : "", icon, link, fieldId, onClose, } = props;
    const [isClosed, setIsClosed] = useState(false);
    const fieldIdProps = fieldId === undefined
        ? {}
        : { "data-field-id": fieldId, "data-field-type": "info" };
    const hasIcon = icon !== undefined;
    const hasLink = link !== undefined;
    const stateClass = isClosed ? "is-closed" : "";
    return (h("div", { class: `m-alert m-alert--${type} m-alert--${variant} ${extraClasses} ${stateClass}`, ...fieldIdProps, role: type === "danger" ? "alert" : "status" },
        variant === "toast" && (h("button", { type: "button", class: "m-alert__close u-btn-unstyled", "aria-label": translate(t.generic.close), onClick: () => {
                setIsClosed(true);
                onClose === null || onClose === void 0 ? void 0 : onClose();
            } },
            h("span", { class: "icon-cancel", "aria-hidden": "true" }))),
        hasIcon && (h("i", { class: `m-alert__icon icon-${icon}`, "aria-hidden": "true" })),
        message,
        hasLink && (h(Fragment, null,
            " ",
            h("a", { href: link.path, class: (_a = link.customClass) !== null && _a !== void 0 ? _a : "m-alert__link", "data-field-id": link.fieldId, onClick: link.onClick, "data-ga-action": link.gaAction }, link.label)))));
}
export default observer(Alert);
